export default "__VITE_PUBLIC_ASSET__0b77f331__"